<template>
  <div class="container">
      <main>
            <Search @getInputValue='getInputValue' @search='search' @add='add'>客户资料</Search>
            <el-table
                :data="list"
                header-align="center"
                :row-class-name="TableRowClassName"
                style="width:100%;padding:0 0px;height:100%"
                :header-cell-style="{ background: '#EBEEF8',height: '45px' }"
                :cell-style="{padding:'0px'}"
            >
            <el-table-column
            label="序号"
            type="index"
            :index="indexMethod"
            align="center"
            >
            </el-table-column>
            <el-table-column
            prop="name"
            label="客户名称"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="address"
            label="客户地址"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="linker"
            label="联系人"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="linkerTel"
            label="联系电话"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="nature"
            label="企业性质"
            align="center"
            show-overflow-tooltip
            >
            <template slot-scope="scope">
                <span>{{scope.row.nature | companyFomart}}</span>
            </template>
            </el-table-column>
            <el-table-column
            prop="trade"
            label="从事行业"
            align="center"
            show-overflow-tooltip
            >
            <template slot-scope="scope">
                <span>{{scope.row.trade | hangYeFomart}}</span>
            </template>
            </el-table-column>
            <el-table-column
            prop="unicode"
            label="统一代码"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            label="操作"
            align="center"
            fixed="right"
            min-width="80"
            width="80"
            >
                <template slot-scope="scope">
                    <div style="display:flex;width:100%;justify-content:space-around">
                        <el-button @click="edit(scope.row)" type="text" size="mini" class="btn">
                            <i class="el-icon-edit-outline" style="fontSize:19px;color:#000"></i>
                        </el-button>
                    </div>
                </template>
            </el-table-column>
            </el-table>
            <Pagination :pageTotal="pageTotal" @currentPage="currentPage"/>
        </main>
        <el-dialog :title="isEdit?'编辑':'新增'"  :visible.sync="dialogFormVisible" center :close-on-click-modal="false" style="width:100%;margin:0 auto;marginTop:-50px">
            <div class="dialogline"></div>
            <div class="dialogdiv">
                <el-form :model="dialogForm" class="dialogForm" :rules="formRules" ref="formRules">
                    <el-form-item label="客户名称" label-width="105px" prop="name">
                        <el-input v-model="dialogForm.name" autocomplete="off" placeholder="请输入客户名称" ></el-input>
                    </el-form-item>
                    <el-form-item label="客户地区" label-width="105px" prop="areaCode">
                        <el-cascader
                            style="width:100%"
                            v-model="dialogForm.areaCode"
                            filterable
                            :ref="hehe"
                            :props="defaultProps"
                            :options="addressTree"
                            @change="handleChange">
                        </el-cascader>
                    </el-form-item>
                    <el-form-item label="详细地址" label-width="105px" prop="address" >
                        <el-input v-model="dialogForm.address" autocomplete="off" placeholder="请输入详细地址" @input="getAddress"></el-input>
                    </el-form-item>
                    <el-form-item label="法人代表" label-width="105px" prop="legalPerson" >
                        <el-input v-model="dialogForm.legalPerson" autocomplete="off" placeholder="请输入法人代表" ></el-input>
                    </el-form-item>
                    <el-form-item label="统一代码" label-width="105px" prop="unicode" >
                        <el-input v-model="dialogForm.unicode" autocomplete="off" placeholder="请输入统一代码" ></el-input>
                    </el-form-item>
                    <el-form-item label="企业性质" label-width="105px" prop="nature" >
                        <el-select  v-model="dialogForm.nature" style="width:100%">
                            <el-option label="央企" value='1'></el-option>
                            <el-option label="国企" value='2'></el-option>
                            <el-option label="私企" value='3'></el-option>
                            <el-option label="其他" value='4'></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="从事行业" label-width="105px" prop="trade" >
                        <el-select  v-model="dialogForm.trade" style="width:100%">
                            <el-option label="建筑行业" value='1'></el-option>
                            <el-option label="租赁企业" value='2'></el-option>
                            <el-option label="其他" value='3'></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="联系人员" label-width="105px" prop="linker" >
                        <el-input v-model="dialogForm.linker" autocomplete="off" placeholder="请输入联系人" ></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话" label-width="105px" prop="linkerTel" >
                        <el-input v-model="dialogForm.linkerTel" autocomplete="off" placeholder="请输入联系电话" ></el-input>
                    </el-form-item>
                </el-form>
                <div class="map">
                    <baidu-map
                        :center="center"
                        :zoom="zoom"
                        :scroll-wheel-zoom="true"
                        @click="getLocation"
                    >
                        <bm-view style="width: 100%; height: 34.375rem; flex: 1"></bm-view>
                        <bm-marker :position="markerCenter" :dragging="true" animation="BMAP_ANIMATION_DROP" @dragend='getLocation'>
                        </bm-marker>
                    </baidu-map>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmForm">{{isEdit?'保 存':'确 定'}}</el-button>
            </div>
        </el-dialog>
  </div>
</template>

<script>
export default {
    data(){
        return{
            option: {
                filter: '',
                pageSize: 15,
                pageIndex: 1
            },
            dialogForm: {
                id: 0,
                name: '',
                areaCode: '',
                address: '',
                legalPerson: '',
                unicode: '',
                nature: '3',
                trade: '1',
                linker: '',
                linkerTel: '',
                gpsX: 0,
                gpsY: 0,
                remark: ''
            },
            center: {
                lng: 116.404,
                lat: 39.915,
            },
            zoom: 15,
            markerCenter:{
                lng: 116.404,
                lat: 39.915,
            },
            formRules:{
                name:[{
                    required: true,
                    message: "请输入厂商名称",
                    trigger: "blur"
                }],
                areaCode:[{
                    required: true,
                    message: "请选择地区",
                    trigger: "blur"
                }],
                address:[{
                    required: true,
                    message: "请输入详细地址",
                    trigger: "blur"
                }],
                legalPerson:[{
                    required: true,
                    message: "请输入法人代表",
                    trigger: "blur"
                }],
                unicode:[{
                    required: true,
                    message: "请输入统一代码",
                    trigger: "blur"
                }],
                nature:[{
                    required: true,
                    message: "请选择企业性质",
                    trigger: "blur"
                }],
                trade:[{
                    required: true,
                    message: "请选择从事行业",
                    trigger: "blur"
                }],
                linker:[{
                    required: true,
                    message: "请输入联系人姓名",
                    trigger: "blur"
                }],
            },
            defaultProps: {
                children: "children",
                label: "title",
                value:'code',
                checkStrictly: true
            },
            pageTotal: 1,
            isEdit: false,
            dialogFormVisible: false,
            dialogFormVisible2: false,
            list: [],
            inputValue: '',
            addressTree: [],
            hehe:'lll'
        }
    },
    methods:{
        //获取list
        getList(option){
            this.$api.CustomerList(option).then(res=>{
                this.list = res.data.data.data;
                this.pageTotal = res.data.data.total;
            })
        },
        //获取地区树
        getAddressTree(){
            this.$api.GetAreaTree().then(res=>{
                this.addressTree = JSON.parse(res.data.data)
            })
        },
        //地区选择框改变
        handleChange(val){
            this.dialogForm.areaCode = val[this.dialogForm.areaCode.length-1];
            this.center = this.$refs.lll.inputValue
        },
        //获取页码
        currentPage(option){
            this.option.pageIndex = option
            this.getList(this.option);
        },
        //表格前编号
        indexMethod(index) {
            return index+1 ;
        },
        //表格隔行变色，样式在app.vue里
        TableRowClassName({row,rowIndex}){
            if(rowIndex%2 != 0){
                return 'backtablegray'
            }else{
                return 'backtablewhite'
            }
        },
        //获取搜索框值
        getInputValue(option){
            this.inputValue = option
        },
        //搜索按钮
        search(){
            this.getList({
                filter: this.inputValue,
                pageSize: 15,
                pageIndex: 1
            });
        },
        //获取项目地址
        getAddress(){
            this.center = this.dialogForm.address;
        },
        //点击地图获取坐标
        getLocation(e){
            this.markerCenter.lng = e.point.lng;
            this.markerCenter.lat = e.point.lat;
            this.dialogForm.gpsX =  e.point.lng;
            this.dialogForm.gpsY =  e.point.lat
        },
        //添加按钮
        add(){
            this.isEdit = false;
            this.dialogFormVisible = true;
            this.dialogForm = {
                id: 0,
                name: '',
                areaCode: '',
                address: '',
                legalPerson: '',
                unicode: '',
                nature: '3',
                trade: '1',
                linker: '',
                linkerTel: '',
                gpsX: 0,
                gpsY: 0,
                remark: ''
            };
            this.center = {
                lng: 116.404,
                lat: 39.915,
            }
            this.markerCenter = {
                lng: 116.404,
                lat: 39.915,
            }
        },
        //编辑按钮
        edit(row) {
            this.isEdit = true;
            this.dialogFormVisible = true;
            this.dialogForm = {
                id: row.id,
                name: row.name,
                areaCode: row.areaCode,
                address: row.address,
                legalPerson: row.legalPerson,
                unicode: row.unicode,
                nature: String(row.nature),
                trade: String(row.trade),
                linker: row.linker,
                linkerTel: row.linkerTel,
                gpsX: row.gpsX,
                gpsY: row.gpsY,
                remark: row.remark
            };
            this.center = {
                lng: row.gpsX,
                lat: row.gpsY,
            }
            this.markerCenter = {
                lng: row.gpsX,
                lat: row.gpsY,
            }
        },
        //dialog提交按钮
        confirmForm(){
            this.$refs.formRules.validate(valid=>{
                if(valid){
                    //可以提交
                    this.dialogForm.nature = Number(this.dialogForm.nature);
                    this.dialogForm.trade = Number(this.dialogForm.trade);
                    if(this.isEdit){
                        this.$api.UpdateCustomer(this.dialogForm).then(res=>{
                            if(res.data.code == 200){
                                this.getList(this.option);
                                this.$notify({
                                    message: res.data.msg,
                                    type: 'success'
                                })
                            }else{
                                this.$notify({
                                    message: res.data.msg,
                                    type: 'error'
                                })
                            }
                        });
                        this.dialogFormVisible = false;
                    }else{
                        if(this.dialogForm.gpsX==0 || this.dialogForm.gpsY==0){
                            this.$message({
                                message: '请在地图上打点！',
                                type: 'warning'
                            });
                        }else{
                            this.$api.AddCustomer(this.dialogForm).then(res=>{
                                if(res.data.code == 200){
                                    this.getList(this.option);
                                    this.$notify({
                                        message: res.data.msg,
                                        type: 'success'
                                    })
                                }else{
                                    this.$notify({
                                        message: res.data.msg,
                                        type: 'error'
                                    })
                                }
                            });
                            this.dialogFormVisible = false;
                        }
                    }
                }else{
                    return false
                }
            })
        }
    },
    mounted(){
        this.getList(this.option);
        this.getAddressTree();
    }
}
</script>

<style lang='scss' scoped>
.container{
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
}
main{
    overflow: hidden;
    background: #fff;
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 0 8px;
}
.dialogdiv{
    display: flex;
    justify-content: space-between;
    height: 34.375rem;
    width: 100%;
    .el-form{
        width: 46%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom: 0;
        border-right:1px solid #ccc;
        padding-right: 20px;
    }
    .map{
        width: 52%;
        height: 34.375rem;
    }
}
</style>